import { EventEmitter, Injectable } from '@angular/core';
import { Accesorial } from '../interfaces/accesorial.interface';
import { IOrder, IStops } from '../interfaces/order.interface';
import { Customer } from '../../customers/models/customer';
import { ChargesResume } from '../models/order';
import { OrderStatusEnum } from '../utils/enums';

@Injectable({
  providedIn: 'root',
})
export class OrderSharedService {
  public customEvent: EventEmitter<any> = new EventEmitter();
  public reloadEvent: EventEmitter<any> = new EventEmitter();
  public reloadDelivery: EventEmitter<any> = new EventEmitter();
  public reloadDriverPay: EventEmitter<any> = new EventEmitter();
  public dateAppoitmentEvent: EventEmitter<Date> = new EventEmitter();
  public updateProfit: EventEmitter<any> = new EventEmitter();
  public reloadAllOrderImgsEvent: EventEmitter<string> = new EventEmitter();

  orderInfo: IOrder;
  private _totalsAccesorials: number;

  constructor() {
    this.orderInfo = this.GetOrder();
  }

  SetOrderToStorage(order: IOrder) {
    if (localStorage.getItem('order')) localStorage.removeItem('order');
    localStorage.setItem('order', JSON.stringify(order));
  }

  GetOrder(): IOrder {
    const serializedObject = localStorage.getItem('order');
    if (!serializedObject) {
      return null;
    }
    try {
      const parsedObject: IOrder = JSON.parse(serializedObject);
      return parsedObject;
    } catch (error) {
      console.error('Error parsing order from localStorage:', error);
      return null;
    }
  }

  GetTotalsAccesorials(): number {
    return this._totalsAccesorials ?? 0;
  }

  SetTotalAccesorials(total: number) {
    this._totalsAccesorials = total;
  }

  SetPrintOrdersToStorage(orders: IOrder[]) {
    if (localStorage.getItem('printTicketOrders'))
      localStorage.removeItem('printTicketOrders');
    localStorage.setItem('printTicketOrders', JSON.stringify(orders));
  }

  GetPrintOrders(): IOrder[] {
    const serializedObject = localStorage.getItem('printTicketOrders');
    if (!serializedObject) {
      return [];
    }
    try {
      const parsedObject: IOrder[] = JSON.parse(serializedObject);
      return parsedObject;
    } catch (error) {
      console.error('Error parsing print orders from localStorage:', error);
      return [];
    }
  }

  SetPrintTicketChargesResumeToStorage(charges: ChargesResume[]) {
    if (localStorage.getItem('printTicketChargesResume'))
      localStorage.removeItem('printTicketChargesResume');
    localStorage.setItem('printTicketChargesResume', JSON.stringify(charges));
  }

  GetPrintTicketChargesResume(): ChargesResume[] {
    const serializedObject = localStorage.getItem('printTicketChargesResume');
    if (!serializedObject) {
      return [];
    }
    try {
      const parsedObject: ChargesResume[] = JSON.parse(serializedObject);
      return parsedObject;
    } catch (error) {
      console.error('Error parsing print ticket charges resume from localStorage:', error);
      return [];
    }
  }

  EmitEventToAccesorialComponent() {
    this.customEvent.emit();
  }

  IsReadOnly(): boolean {
    const permittedStatus: number[] = [
      OrderStatusEnum.Open,
      OrderStatusEnum.Reviewed,
    ];
    if (!permittedStatus.includes(this.GetOrder()?.statusID)) return true;
    return false;
  }

  SetOrderDetToReadOnly() {
    if (this.IsReadOnly()) {
      document
        .querySelectorAll('has_read_mode')
        .forEach((input: HTMLInputElement) => {
          input.readOnly = true;
        });

      document
        .querySelectorAll('.has_read_mode')
        .forEach((select: HTMLSelectElement) => {
          select.disabled = true;
        });

      document
        .querySelectorAll('.has_read_mode')
        .forEach((span: HTMLSpanElement) => {
          span.onclick = null;
        });
    }
  }

  //#region --> Stops Modal Section

  stopList: IStops[] = [];
  customerList: Customer[] = [];
  stopsIds: number[] = [0];

  AddNewStop(amountCalculatedByBackend?: boolean) {
    this.stopList.push({
      multiStopsId: null,
      shipperOrConsigneeId: 0,
      shiperOrConsigneeName: null,
      amount: 0,
      appointmentNumber: '',
      apptDate: null,
      pickupNumber: '',
      releaseNumber: '',
      ponumber: '',
      dateIn: null,
      dateOut: null,
      seqNo: 0,
      amountCalculatedByBackend: amountCalculatedByBackend,
    });
  }

  SetStopIdx(): number {
    const lastId: number = this.stopsIds[this.stopsIds.length - 1];
    this.stopsIds.push(lastId + 1);
    return lastId + 1;
  }

  RemoveStop(idx: number) {
    this.stopList.splice(idx, 1);
  }

  // #endregion

  //#region --> Accesorial Modal Section

  accesorialList: Accesorial[] = [];

  AddNewAccesorial() {
    const newAccesorial: Accesorial = {
      id: this.accesorialList.length + 1,
      category: '',
      descr: '',
      amount: 0,
      driverPercentage: 0,
      driverAmount: 0,
    };
    this.accesorialList.push(newAccesorial);
  }

  RemoveAccesorial(idx: number) {
    this.accesorialList.splice(idx, 1);
  }

  SaveAccesorial(idx: number) {
    const category = document.getElementById(
      idx + 'category',
    ) as HTMLInputElement;
    const descr = document.getElementById(idx + 'descr') as HTMLInputElement;
    const amount = document.getElementById(idx + 'amount') as HTMLInputElement;
    const driverPercentage = document.getElementById(
      idx + 'driver',
    ) as HTMLInputElement;
    const driverAmount = document.getElementById(
      idx + 'driverAmount',
    ) as HTMLInputElement;

    const newAccesorial: Accesorial = {
      id: idx,
      category: category.value,
      descr: descr.value,
      amount: +amount.value,
      driverPercentage: +driverPercentage.value,
      driverAmount: +driverAmount.value,
    };

    console.log(newAccesorial);
  }

  ClearAccesorials() {
    this.accesorialList = [];
  }

  // #endregion
}
